import { render } from "./tasksList.vue?vue&type=template&id=7749d183&scoped=true"
import script from "./tasksList.vue?vue&type=script&lang=js"
export * from "./tasksList.vue?vue&type=script&lang=js"

import "./tasksList.vue?vue&type=style&index=0&id=7749d183&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7749d183"]])

export default __exports__